import React from "react";
import LoginForm from "./LoginForm";

const SignInPage = () => {
  return <LoginForm />;
};

export default SignInPage;
